// shinning stars animation
const container = document.querySelector('#star-animation') as HTMLElement;
const canvas = document.querySelector('#star') as HTMLCanvasElement;
const context = canvas.getContext('2d') as CanvasRenderingContext2D;
let gradient: CanvasGradient | null = null;
const stars: Circle[] = [];

const maxParticles = 50;
const drawInterval = 30;

let width = 0;
let height = 0;

function setDimensions(e?: Event): void {
  width = container.offsetWidth;
  height = container.offsetHeight;

  canvas.width = width;
  canvas.height = height;
  stars.forEach(star => star.reset(true));
}

window.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    setDimensions();
  }, 1000);
});
window.addEventListener('resize', setDimensions);

class Circle {
  settings!: {
    ttl: number;
    xmax: number;
    ymax: number;
    rmax: number;
    rt: number;
    xdef: number;
    ydef: number;
    xdrift: number;
    ydrift: number;
    random: boolean;
    blink: boolean;
  };

  x!: number;
  y!: number;
  r!: number;
  dx!: number;
  dy!: number;
  hl!: number;
  rt!: number;
  stop!: number;

  constructor() {
    this.settings = {
      ttl: 8000,
      xmax: 5,
      ymax: 2,
      rmax: 10,
      rt: 1,
      xdef: 960,
      ydef: 540,
      xdrift: 4,
      ydrift: 4,
      random: true,
      blink: true
    };
    this.reset();
  }

  reset(onResize = false): void {
    if (onResize) {
      this.x = this.settings.random ? width * Math.random() : this.settings.xdef;
      this.y = this.settings.random ? height * Math.random() : this.settings.ydef;
    } else {
      this.x = this.settings.random ? width * Math.random() : this.settings.xdef;
      this.y = this.settings.random ? height * Math.random() : this.settings.ydef;
    }
    this.r = (this.settings.rmax - 1) * Math.random() + 1;
    this.dx = Math.random() * this.settings.xmax * (Math.random() < 0.5 ? -1 : 1);
    this.dy = Math.random() * this.settings.ymax * (Math.random() < 0.5 ? -1 : 1);
    this.hl = (this.settings.ttl / drawInterval) * (this.r / this.settings.rmax);
    this.rt = Math.random() * this.hl;
    this.settings.rt = Math.random() + 1;
    this.stop = Math.random() * 0.2 + 0.4;
    this.settings.xdrift *= Math.random() * (Math.random() < 0.8 ? -1 : 1);
    this.settings.ydrift *= Math.random() * (Math.random() < 0.8 ? -1 : 1);
  }

  fade(): void {
    this.rt += this.settings.rt;
  }

  draw(): void {
    if (this.settings.blink && (this.rt <= 0 || this.rt >= this.hl)) {
      this.settings.rt *= -1;
    } else if (this.rt >= this.hl) {
      this.reset();
    }

    const newo: number = 1 - (this.rt / this.hl);
    context.beginPath();
    context.arc(this.x, this.y, this.r, 0, Math.PI * 2, true);
    context.closePath();

    const cr: number = this.r * newo;
    gradient = context.createRadialGradient(this.x, this.y, 0, this.x, this.y, (cr <= 0 ? 1 : cr));
    gradient.addColorStop(0.0, `rgba(0,255,255,${newo})`);
    gradient.addColorStop(this.stop, `rgba(0,255,255,${newo * 0.6})`);
    gradient.addColorStop(1.0, 'rgba(0,255,255,0)');
    context.fillStyle = gradient;
    context.fill();
  }

  move(): void {
    this.x += (this.rt / this.hl) * this.dx;
    this.y += (this.rt / this.hl) * this.dy;
    if (this.x > width || this.x < 0) this.dx *= -1;
    if (this.y > height || this.y < 0) this.dy *= -1;
  }
}

for (let i = 0; i < maxParticles; i++) {
  stars.push(new Circle());
}

function draw(): void {
  context.clearRect(0, 0, width, height);
  for (let i = 0; i < stars.length; i++) {
    stars[i].fade();
    stars[i].move();
    stars[i].draw();
  }
}

setInterval(draw, drawInterval);
